export default {
    path: '/title-research-queue/:productCode?',
    name: 'TitleResearchQueue',
    props: true,
    meta: {
        requiresAuth: true,
        title: 'My Research Queue',
        documentTitle: 'My Research Queue',
        detailParam: 'productCode',
    },
    component: () => import( /* webpackChunkName: "TitleResearchQueue" */ '@/views/TitleResearch/Queue' ),
};
